import React from "react";
import "./App.css";
import Form from "./components/Form/Form";

function App() {
  return (
    <div className="App">
      <React.StrictMode>
        <Form />
      </React.StrictMode>
    </div>
  );
}

export default App;